
var SCM = SCM || {};

SCM.Common = (function () {

    return {
        getQueryStringValue: getQueryStringValue,
        isDefined: isDefined
    };

    //Retrieves the values of a key from dataUrl
    function getQueryStringValue(dataUrl, key) {
        var keyValue;
        var startText = key + '=';
        var endText = '&';
        var qPos = dataUrl.indexOf(startText);

        if (qPos === -1) {
            //key doesn't exist.
            return null;
        }
        else {
            qPos = qPos + startText.length;
        }

        if (dataUrl.indexOf('&', qPos) >= 0) {
            var ampPos = dataUrl.indexOf(endText, qPos);
            keyValue = dataUrl.substring(qPos, ampPos);
        }
        else {
            //data-url will be just like q=obesity
            keyValue = dataUrl.substring(qPos);
        }

        return keyValue;
    }
    
    function isDefined(element) {
        return typeof element !== 'undefined' && element !== undefined && element != null;
    }
    
})();
